<template>
    <form>
        <brand-selection :brands="brands" :load-selected="selectedBrands">
            <div class="mt-5">
                <button class="btn btn-primary" @click.prevent="submitBrands">
                    <span class="svg-icon svg-icon-md"><i class="text-white fas fa-save"></i></span>
                    {{ __('actions.submit') }}
                </button>
            </div>
        </brand-selection>
    </form>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import BrandSelection from '@components/BrandSelection.vue'

export default {
    components: {BrandSelection},
    layout: Navigation,

    name: 'EditStoreBrand',

    props: {
        brands: Array,
        selectedBrands: Array,
        storeUuid: String,
    },

    data() {
        return {
            newSelectedBrands: [],
        }
    },

    methods: {
        getSelected() {
            let brandArray = []
            for (const brand of this.selectedBrands) {
                brandArray.push(brand.uuid)
            }
            return brandArray
        },
        submitBrands() {
            let selectedBrands = this.getSelected()

            this.$inertia.post(this.$route('store.brand.update', [this.storeUuid]), {
                brand_uuids: selectedBrands,
            })
        },
    },
}
</script>
